import { useAdvancedSearchStore } from "@context/useAdvancedSearchStore";
import { useMemo } from "react";

export const useSharedAdvancedSearchStore = () => {
  const error = useAdvancedSearchStore(state => state?.error);
  const daysError = useAdvancedSearchStore(state => state?.daysError);
  const timeRangeError = useAdvancedSearchStore(state => state?.timeRangeError);
  const days = useAdvancedSearchStore(state => state?.days) ?? [];
  const blockRange = useAdvancedSearchStore(state => state?.blockRange) ?? {};
  const intervalRange = useAdvancedSearchStore(state => state?.intervalRange) ?? null;
  const intervals = useAdvancedSearchStore(state => state?.intervals) ?? null;

  const objAvailability = useMemo(() => {
    const newObj: any = {
      availability: {
        dayId: days,
        blockRange,
        intervalRange,
        intervals,
      },
    };

    if (!days?.length) {
      delete newObj.availability.dayId;
    }

    if (!blockRange?.start && !blockRange?.end) {
      delete newObj.availability.blockRange;
    }

    if (!intervalRange) {
      delete newObj.availability.intervalRange;
    }

    if (!intervals?.length || !intervalRange) {
      delete newObj.availability.intervals;
    }

    return Object.keys(newObj?.availability)?.length > 0 ? newObj : {};
  }, [days, blockRange, intervalRange, intervals]);

  return {
    objAvailability,
    error,
    daysError,
    timeRangeError,
    intervalRange,
    intervals,
    days,
    blockRange,
  };
};
